var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChordG7 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 600 600",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#00a6a8",
  strokeMiterlimit: 10,
  strokeWidth: 27.99,
  d: "M115.11 112.04h371.92v371.92H115.11z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#f283b2",
  strokeMiterlimit: 10,
  strokeWidth: 21.83,
  d: "M51.92 118.55a63.2 63.2 0 1163.19 63.2 63.19 63.19 0 01-63.19-63.2z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#00a6a8",
  strokeMiterlimit: 10,
  strokeWidth: 21.83,
  d: "M51.92 480a63.2 63.2 0 1163.19 63.2A63.19 63.19 0 0151.92 480z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#00a6a8",
  stroke: "#00a6a8",
  strokeMiterlimit: 10,
  strokeWidth: 8.21,
  d: "M130.44 503.59a45.69 45.69 0 01-15.07 2.69c-7.42 0-13.54-1.89-18.34-6.48-4.22-4.08-6.84-10.63-6.84-18.27.07-14.63 10.11-25.34 26.57-25.34a30.3 30.3 0 0112.24 2.26l-1.53 5.17a25.37 25.37 0 00-10.85-2.11c-11.94 0-19.73 7.42-19.73 19.73s7.5 19.8 18.93 19.8c4.15 0 7-.58 8.45-1.31V485.1h-10V480h16.16z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#f283b2",
  strokeMiterlimit: 10,
  strokeWidth: 8.21,
  d: "M101.62 93.9a61.75 61.75 0 0111.64-.9c6.37 0 10.46 1.16 13.52 3.64a10.18 10.18 0 014.06 8.63c0 4.7-3.19 8.79-8.4 10.63v.1c4.68 1.19 10.15 5.07 10.11 12.29a13 13 0 01-4.22 9.72c-3.45 3.08-9 4.49-17.07 4.42a74.15 74.15 0 01-9.88-.65zm6.15 43.33a35.58 35.58 0 005.34.33c6.59.05 12.67-2.29 12.71-9.37 0-6.65-5.74-9.44-12.69-9.49h-5.27zm.12-23.34h5.78c6.73 0 10.7-3.38 10.73-8.08 0-5.71-4.36-8-10.79-8a27.72 27.72 0 00-5.64.39z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#00a6a8",
  stroke: "#00a6a8",
  strokeMiterlimit: 10,
  strokeWidth: 10.35,
  d: "M305.38 218.1q14.91 4.28 17.11 4.27 5.7 0 8.1-2.2a17.48 17.48 0 004.09-6.35h5.83l2.07 55.87h-6.09q-8.16-19.31-16.85-28.78-15.64-16.59-40.84-16.59-25.53 0-44.92 19.38t-19.38 63.84q0 36.69 19.32 57.3t47.71 20.62a83.62 83.62 0 0011.27-.91 68.56 68.56 0 0012.32-2.85q9.47-3.09 11.8-5.36t2.33-6.66v-42.3q0-15.37-4.34-19.16t-19-4.69v-4.93h67.67v4.93q-9.85.64-13.1 3.24-5.44 4.14-5.44 17.11v52.24q0 4.67-22.88 12.45t-44 7.78q-38.9 0-65.6-22.69-29.43-25-29.43-67.15 0-37.08 23.47-63.52 25.78-29.18 68.44-29.17a109.17 109.17 0 0130.34 4.28z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#6bbe46",
  stroke: "#6bbe46",
  strokeMiterlimit: 10,
  strokeWidth: 5.2,
  d: "M423.62 188.07v2.15l-28.27 87.35h-8.56l26.33-79.66h-28.39q-6.32 0-9.09 2.08t-7 8.73l-2.28-1q4.25-10.43 5.25-12.87t2.64-6.74z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 484.41,
  cy: 112.04,
  r: 63.19,
  fill: "#fff",
  stroke: "#faa725",
  strokeMiterlimit: 10,
  strokeWidth: 21.83,
  transform: "rotate(-89.27 484.39 112.057)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#faa725",
  stroke: "#faa725",
  strokeMiterlimit: 10,
  strokeWidth: 6.51,
  d: "M469.19 91.36a91.46 91.46 0 0113.39-1.13c9-.07 15.5 2 19.79 5.92s6.93 9.57 7 17.46-2.38 14.5-6.92 19-12.05 7.12-21.53 7.2a102 102 0 01-11.44-.49zm6.53 43.09a39.32 39.32 0 006.37.31c13.46-.11 20.74-7.7 20.66-20.88 0-11.51-6.54-18.76-19.86-18.65a35.1 35.1 0 00-7.38.71z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#6bbe46",
  strokeMiterlimit: 10,
  strokeWidth: 21.29,
  d: "M548.08 480.87a61.64 61.64 0 11-61.63-61.64 61.63 61.63 0 0161.63 61.64z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#6bbe46",
  stroke: "#6bbe46",
  strokeMiterlimit: 10,
  strokeWidth: 6.51,
  d: "M472.29 456.63h26.28v5.28h-20v16.22h18.46v5.21h-18.44v22.08h-6.3z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChordG7);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chord-g7.928423cfc42ab5cc4ff134b35030f355.svg";